import { useEffect, useState } from "react";
import { useGateApi } from "../Api/useGateApi";
import { AuthGateApiClient } from "../Api/ApiServerHooks";
import { Autocomplete, Box, Button, Dialog, DialogContent, TextField } from "@mui/material";
import MuiDialogHeader from "../Shared/MuiDialogHeader";
import { useTranslation } from 'react-i18next';

interface ChooseTenantDialogProps {
    onClose: (vyber: number | undefined) => void;
    isOpen: boolean;
    selectedTenantId?: number
}

export default function ChooseTenantDialog(props: Readonly<ChooseTenantDialogProps>) {
    const { onClose, isOpen, selectedTenantId } = props;
    const { t } = useTranslation();
    const [selected, setSelected] = useState<number | undefined>(1);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [options, setOptions] = useState<{ label: string, id: number }[]>([]);
    const { authorizedApiForTenants, authorizedApi, AuthorizedForTenants } = useGateApi(AuthGateApiClient);
    useEffect(() => {
        if (isOpen)
            if (selectedTenantId === undefined) {
                AuthorizedForTenants().getTenants().then((res) => {
                    let tenants: Array<{ label: string, id: number }> = [];
                    if (res.tenants)
                        for (let key of res.tenants) {
                            let ten = { label: key.name!, id: key.id! };
                            tenants.push(ten);
                        }
                    setOptions(tenants);
                })
            }
            else authorizedApi?.getTenantsRegularToken().then((res) => {
                let tenants: Array<{ label: string, id: number }> = [];
                if (res.tenants)
                    for (let key of res.tenants) {
                        let ten = { label: key.name!, id: key.id! };
                        tenants.push(ten);
                    }
                setOptions(tenants);
            })
    }, [isOpen, authorizedApiForTenants, selectedTenantId]);

    return (
        <Dialog maxWidth='lg' sx={{ minHeight: '300px' }} onClose={() => onClose(undefined)} open={isOpen}>
            <MuiDialogHeader title={t('Auth.SelectTenant')} onClose={() => onClose(undefined)} />
            <DialogContent sx={{ background: 'white' }}>
                <Box sx={{ margin: '10px' }}>
                    <Box sx={{ minHeight: '300px' }}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={options}
                            onChange={(e, v) => {
                                if (v)
                                    setSelected(v.id);
                                else
                                    setSelected(undefined);
                            }}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            value={selectedTenantId && options ? options.find(s => s.id === selectedTenantId) : undefined}
                            sx={{ width: 300 }}
                            slotProps={{
                                // výška se omezuje na seznamu; papír s vlastním posuvníkem by přidal druhý scrollbar
                                listbox: {
                                    sx: { maxHeight: 250 }
                                }
                            }}
                            renderInput={(params) => <TextField {...params} label={t('Auth.Select')} />}
                        />
                    </Box>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                        <Button variant='contained' sx={{ margin: 'auto' }} disabled={!selected || buttonDisabled} onClick={() => {
                            setButtonDisabled(true);
                            if (selected)
                                onClose(selected);
                            setButtonDisabled(false);
                        }}>{t('SelectButton')}</Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    )
}